import { render, staticRenderFns } from "./viewAskInfo.vue?vue&type=template&id=6cc4088c&scoped=true"
import script from "./viewAskInfo.vue?vue&type=script&lang=js"
export * from "./viewAskInfo.vue?vue&type=script&lang=js"
import style0 from "./viewAskInfo.vue?vue&type=style&index=0&id=6cc4088c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4088c",
  null
  
)

export default component.exports